/* eslint-disable prettier/prettier */
import { AccordionFragment } from '@core-mkt/shared/components/accordion/accordion/accordion-query-fragment';
import { InfographicsFragment } from '@core-mkt/shared/components/infographics/infographics/infographics-query-fragment';
import { PopularCoursesFragment } from '@core-mkt/shared/components/popular-courses/popular-courses/popular-courses-query-fragment';
import { AmbassadorInvFragment } from '@core-mkt/shared/components/ambassador-invite/ambassador-invite/ambassador-invite-query-fragment';
import { AmbassadorRefFragment } from '@core-mkt/shared/components/ambassador-referral/ambassador-referral/ambassador-referral-query-fragment';
import { ReferAFriendGlobalFragment } from '@core-mkt/shared/components/refer-a-friend-container/refer-a-friend-container/refer-a-friend-global-query-fragment';
import { AnchorButtonFragment } from '@core-mkt/shared/components/anchor-button/anchor-button/anchor-button-query-fragment';
import { AnchorFragment } from '@core-mkt/shared/components/anchor/anchor/anchor-query-fragment';
import { BannerFragment } from '@core-mkt/shared/components/banner/banner/banner-query-fragment';
import { BreadcrumbFragment } from '@core-mkt/shared/components/breadcrumb/breadcrumb/breadcrumb-query-fragment';
import { BundleBuilderFragment } from '@core-mkt/shared/components/bundle-builder/bundle-builder/bundle-builder-query-fragment';
import { BundleFragment } from '@core-mkt/shared/components/bundle/bundle/bundle-query-fragment';
import { CareerCenterFragment } from '@core-mkt/shared/components/career-center/career-center/career-center-query-fragment';
import { CareersFragment } from '@core-mkt/shared/components/careers/careers/careers-query-fragment';
import { GlobalEmailCaptureFragment } from '@core-mkt/shared/components/email-capture/email-capture/email-capture-query-fragment';
import { EmailFormFragment } from '@core-mkt/shared/components/email-form/email-form/email-form-query-fragment';
import { GlobalPhoneCaptureFragment } from '@core-mkt/shared/components/phone-capture/phone-capture/phone-capture-query-fragment';
import { EntryListingsFragment } from '@core-mkt/shared/components/entry-listings/entry-listings/entry-listings-query-fragment';
import { FaqFragment } from '@core-mkt/shared/components/faq/faq/faq-query-fragment';
import { FeaturedArticleFragment } from '@core-mkt/shared/components/featured-article/featured-article/featured-article-query-fragment';
import { FreeformHtmlFragment } from '@core-mkt/shared/components/freeform-html/freeform-html/freeform-html-query-fragment';
import { GladlyFragment } from '@core-mkt/shared/components/gladly-help-center/gladly-help-center/gladly-help-center-query-fragment';
import {
  GlobalGraphicBannerFragment,
  GraphicBannerFragment,
} from '@core-mkt/shared/components/graphic-banner/graphic-banner/graphic-banner-query-fragment';
import { HeroFragment } from '@core-mkt/shared/components/hero-homepage/hero-homepage/hero-homepage-query-fragment';
import { HubspotFragment } from '@core-mkt/shared/components/hubspot/hubspot/hubspot-query-fragment';
import { LayoutFragment } from '@core-mkt/shared/components/layout/layout/layout-query-fragment';
import { LearnMoreFragment } from '@core-mkt/shared/components/learn-more/learn-more/learn-more-query-fragment';
import { MultiColumnFragment } from '@core-mkt/shared/components/multi-column/muti-column/multi-column-query-fragment';
import { MultiIconFragment } from '@core-mkt/shared/components/multi-icon/multi-icon/multi-icon-query-fragment';
import { PriceSelectorFragment } from '@core-mkt/shared/components/price-selector/price-selector/price-selector-query-frament';
import { PricingTableFragment } from '@core-mkt/shared/components/pricing-table/pricing-table/pricing-table-fragment';
import { ProductCardFragment } from '@core-mkt/shared/components/product-card/product-card/product-card-query-fragment';
import { QuizWidgetFragment } from '@core-mkt/shared/components/quiz-widget/quiz-widget/quiz-widget-query-fragment';
import { ResourcesFragment } from '@core-mkt/shared/components/resources/resources/resources-query-fragment';
import { ReviewsFragment } from '@core-mkt/shared/components/reviews/reviews/reviews-query-fragment';
import { RsaProductFragment } from '@core-mkt/shared/components/rsa-product/rsa-product/rsa-product-query-fragment';
import { SideProductPickerFragment } from '@core-mkt/shared/components/side-product-picker/side-product-picker/side-product-picker-query-fragment';
import { SliderCardFragment } from '@core-mkt/shared/components/slider-card/slider-card/slider-card-query-fragment';
import { SliderFragment } from '@core-mkt/shared/components/slider/slider/slider-query-fragment';
import { StandAloneCtaFragment } from '@core-mkt/shared/components/stand-alone-cta/stand-alone-cta/stand-alone-cta-query-fragment';
import { StudyPlanBuilderFragment } from '@core-mkt/shared/components/study-plan-builder/study-plan-builder/study-plan-builder-query-fragment';
import { TabFragment } from '@core-mkt/shared/components/tabbed-content/tabbed-content/tabbed-content-query-fragment';
import { TopBundleFragment } from '@core-mkt/shared/components/top-product/top-product/top-bundle-query-fragment';
import { TopSectionFragment } from '@core-mkt/shared/components/top-section/top-section/top-section-query-fragment';
import { TrustPilotFragment } from '@core-mkt/shared/components/trustpilot/trustpilot/trustpilot-query-fragment';
import { ProductFragment } from '@core-mkt/shared/craft/product-entry-fragment';
import { v3SEOFragment } from '@core-mkt/shared/craft/seo-fragment-query';

import * as gql from 'fake-tag';

export const TemplateSingleQuery = {
  name: 'TemplateSingleQuery',
  // `fake-tag` ships no type declarations, so `gql` resolves to `any`. Typing it requires
  // switching all 46 `import * as gql` sites to a default import — tracked in EPS-3772.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  query: gql`
    query ($site: [String], $slug: [String]) {
      entryData: entries(site: $site, slug: $slug) {
        slug
        typeHandle
        dateCreated
        dateUpdated
        postDate
        title
        ... on visionTemplateEntry_Entry {
          pageTitle
          pageType
          trustPilotSKU
          blogSummary
          featuredEntryImage {
            ... on images_Asset {
              url
              altText
            }
          }
          baseComponents {
            ...BreadcrumbQuery
            ...AccordionQuery
            ...AmInvQuery
            ...AmRefQuery
            ...AnchorQuery
            ...AnchorButtonQuery
            ...BundleQuery
            ...CareersQuery
            ...EmailFormQuery
            ...EntryListingsQuery
            ...FaqQuery
            ...GladlyHCQuery
            ...GraphicBannerQuery
            ...HeroQuery
            ...HubspotQuery
            ...LayoutQuery
            ...LearnMoreQuery
            ...MultiColumnQuery
            ...MultiIconQuery
            ...PriceSelectorQuery
            ...pricingTableQuery
            ...ProductCardQuery
            ...QuizWidgetQuery
            ...ResourcesQuery
            ...ReviewsQuery
            ...RsaProductQuery
            ...SideProductPickerQuery
            ...SliderQuery
            ...SliderCardQuery
            ...StandAloneCtaQuery
            ...StudyPlanBuilderQuery
            ...TabQuery
            ...TopBundleQuery
            ...TopSectionQuery
            ...FeaturedArticleQuery
            ...TrustPilotQuery
            ...CareerCenterQuery
            ...BundleBuilderQuery
            ...InfographicsQuery
            ...PopularCoursesQuery
            ...FreeformHtmlQuery
          }
        }
      }

      pageOptions: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          title
          pageType
          ogPageVersion
          trustPilotSKU
          adaChatbot
          product {
            ...ProductEntry
          }
        }
      }

      headerData: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          hideFooter
          hideNav
          hideStickyBanner
          isNavSticky
          hasInPersonLessons
          stickyEmailOverride
          additionalHeaderLogo {
            url
            ... on images_Asset {
              altText
            }
          }
          pageState
          trustPilotSKU
        }
      }

      exitIntentModal: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          titleModal
          contentModal
          imageModal {
            url
            ... on images_Asset {
              altText
            }
          }
          imagePlacement
          buttonLabelModal
          buttonLinkModal
          buttonStyleModal
          enabledExitModal
          bottomSectionModal
          triggerTypeModal
          postSubmissionMessage
          iterableListId
        }
      }

      structuredData: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          structuredData
        }
      }

      seoContent: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          ...v3SEOFragment
        }
      }

      styles: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          embedStyles
        }
      }

      product: entries(site: $site, slug: $slug) {
        ...ProductEntry
      }

      adobe: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          pageName
          var1
          var2
          var3
          var4
          var5
          appStep
          transactionId
          paymentType
          productId
          orderAmount
          registrationType
        }
      }

      optimizely: entries(site: $site, slug: $slug) {
        ... on visionTemplateEntry_Entry {
          optimizelyEnabled
          optimizelyTestEndDate
        }
      }

      stickyEmailCapture: globalSets(site: $site) {
        ... on aceHeader_GlobalSet {
          emailCapture {
            ...GlobalEmailCaptureQuery
          }
          phoneCapture {
            ...GlobalPhoneCaptureQuery
          }
        }
      }

      globalOptimizely: globalSets(site: $site) {
        ... on aceHeader_GlobalSet {
          globalOptimizely
        }
      }

      banners: globalSets(site: $site) {
        ... on aceHeader_GlobalSet {
          graphicPromoBanner {
            ...GlobalGraphicBannerQuery
          }
          topBanner {
            ...BannerQuery
          }
        }
      }

      referAFriendConfig: globalSets(site: $site) {
        ... on aceHeader_GlobalSet {
          ...ReferAFriendGlobalQuery
        }
      }
    }
    ${ProductFragment.product}
    ${v3SEOFragment.seoContent}
    ${BreadcrumbFragment.Breadcrumb}
    ${AccordionFragment.Accordion}
    ${AmbassadorInvFragment.AmInv}
    ${AmbassadorRefFragment.AmRef}
    ${ReferAFriendGlobalFragment.RAF}
    ${AnchorFragment.Anchor}
    ${AnchorButtonFragment.AnchorButton}
    ${BundleFragment.Bundle}
    ${PricingTableFragment.pricingTable}
    ${CareersFragment.Careers}
    ${CareerCenterFragment.CareerCenter}
    ${EmailFormFragment.EmailForm}
    ${EntryListingsFragment.EntryListings}
    ${FaqFragment.FAQ}
    ${GladlyFragment.GHC}
    ${GlobalEmailCaptureFragment.GlobalEmailCapture}
    ${GlobalPhoneCaptureFragment.GlobalPhoneCapture}
    ${GlobalGraphicBannerFragment.GlobalGraphicBanner}
    ${GraphicBannerFragment.GraphicBanner}
    ${HeroFragment.Hero}
    ${HubspotFragment.Hubspot}
    ${LayoutFragment.Layout}
    ${LearnMoreFragment.LearnMore}
    ${MultiColumnFragment.MultiColumn}
    ${MultiIconFragment.MultiIcon}
    ${PriceSelectorFragment.PriceSelector}
    ${ProductCardFragment.ProductCard}
    ${QuizWidgetFragment.Quiz}
    ${ResourcesFragment.Resources}
    ${ReviewsFragment.Reviews}
    ${RsaProductFragment.RsaProduct}
    ${SideProductPickerFragment.SideProductPicker}
    ${SliderFragment.Slider}
    ${SliderCardFragment.SliderCard}
    ${StandAloneCtaFragment.StandAloneCta}
    ${TabFragment.TabComponent}
    ${TopBundleFragment.TopBundle}
    ${TopSectionFragment.TopSection}
    ${TrustPilotFragment.TrustPilot}
    ${BannerFragment.Banner}
    ${StudyPlanBuilderFragment.StudyPlanBuilder}
    ${BundleBuilderFragment.BundleBuilder}
    ${FeaturedArticleFragment.FeaturedArticle}
    ${InfographicsFragment.Infographics}
    ${PopularCoursesFragment.PopularCourses}
    ${FreeformHtmlFragment.FreeformHtml}
  `,
};
